import * as React from "react";

interface IProps {
  children: any;
  subheading?: boolean;
  color?: string;
}

const H3 = (props: IProps) => {
  const color = props.color ? props.color : 'white'
  const size = props.subheading ? 'lg' : '2xl'
  return (
    <h3 className={ `text-${ color } font-montserrat text-${ size } mb-2` }>
      {props.children}
    </h3>
  );
};

export default H3;



// WEBPACK FOOTER //
// ./src/components/general/headings/H3.tsx